import { connect } from 'react-redux'

import { getVehicles } from 'src/modules/Claims/Vehicles/actions'
import {
  setVehicleAndDriver,
  otherDriversLicenseAdd,
  otherDriversLicenseRemove,
  clearOtherDriverLicenseFile,
} from './actions'

import OtherVehicleAndDriver from './OtherVehicleAndDriver'

const mapDispatchToProps = {
  setVehicleAndDriver,
  getVehicles,
  otherDriversLicenseAdd,
  otherDriversLicenseRemove,
  clearOtherDriverLicenseFile,
}

const mapStateToProps = state => {
  return {
    vehicleAndDriver: state.vehicleAndDriver.vehicleAndDriver,
    otherDriversLicenseFile: state.vehicleAndDriver.otherDriversLicenseFile,
    deleteOtherDriverLicenseResponse: state.vehicleAndDriver.deleteOtherDriverLicenseResponse,
    isWidgetState: state.appReducer.isWidget,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OtherVehicleAndDriver)
